import { useCallback, useState, useContext, useEffect, Suspense } from "react";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import {
  addEmployeeRequestSubCategory,
  deleteEmployeeRequestSubCategory,
} from "../TicketManagement/TicketService";
import { useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

const EmployeeRequestSubCategory = () => {
  const [columns, setColumns] = useState(["Category", "Subcategory", "Desc"]);
  const [editIndex, setEditIndex] = useState(null);
  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [empReqCategoryId, setEmpReqCategoryId] = useState(null);
  const [isLoading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [errors, setErrors] = useState({});
  const { GUID } = useParams();
  const [data, setData] = useState({
    CategoryId: "",
    Name: "",
    Desc: "",
  });

  useEffect(() => {
    getMasterTicketCategory();
    getMasterTicketSubCategory();
  }, []);

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTicketCategoryType(data?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTicketSubcategoryType(data?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  const validateOrgRequestSubCategory = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-CategoryId`] =
      !data.CategoryId || data.CategoryId.toString().trim() === ""
        ? "Category is required"
        : undefined;
    newErrors[`${index}-Name`] =
      !data.Name || data.Name.trim() === "" ? "Name is required" : undefined;
    newErrors[`${index}-Desc`] =
      !data.Desc || data.Desc.trim() === "" ? "Desc is required" : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  const subCategoryForm = useFormik({
    initialValues: {
      CategoryId: "",
      Name: "",
      Desc: "",
      Id: "",
      CreatedDate: "",
    },
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        Id: data?.Id || 0,
        GUID: GUID,
        IsActive: true,
        CreatedDate: data.CreatedDate || new Date().toISOString(),
        ModifiedDate: new Date().toISOString(),
        CreatedBy: 0,
        ModifiedBy: 0,
        OrgId: userDetails?.OrgId,
        CategoryId: data?.CategoryId,
        Name: data?.Name,
        Desc: data?.Desc,
      };
      try {
        await addEmployeeRequestSubCategory(body);
        if (data.Id) {
          GetMasterSystemAlertList("Award_Updated", 0);
          setEditIndex(null);
        } else {
          setEditIndex(null);
          GetMasterSystemAlertList("Award_Added", 0);
        }
        setTimeout(() => {
          getMasterTicketSubCategory();
        }, 1000);
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        // setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (value) {
        setTicketSubcategoryType((prev) =>
          prev.filter(
            (item) =>
              item.Name?.toLowerCase().includes(value.toLowerCase()) ||
              item.Desc?.toLowerCase().includes(value.toLowerCase()) ||
              item.CategoryName?.toLowerCase().includes(value.toLowerCase())
          )
        );
      } else {
        getMasterTicketSubCategory();
      }
    }, 800),
    []
  );

  const handleAddRow = () => {
    subCategoryForm.resetForm();
    setTicketSubcategoryType([
      ...ticketSubcategoryType,
      { Name: "", CategoryId: "", Desc: "" },
    ]);
    setEditIndex(ticketSubcategoryType.length);
  };

  const handleEditClick = (index) => {
    setEditIndex(index);
    const item = ticketSubcategoryType[index];
    subCategoryForm.setValues({
      CategoryId: item.CategoryId || "",
      Name: item.Name || "",
      Desc: item.Desc || "",
    });
  };

  const handleEmpReqCategory = (Id) => {
    setEmpReqCategoryId(Id);
  };

  async function DeleteOrgEmpRequestCategory() {
    setIsloading(true);
    if (empReqCategoryId) {
      let body = {
        Id: empReqCategoryId,
      };
      try {
        let empReqCategoryList = await deleteEmployeeRequestSubCategory(body);
        if (empReqCategoryList) {
          setIsloading(false);
          getMasterTicketSubCategory();
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const handleCancelEdit = () => {
    setTicketSubcategoryType((prevList) => {
      if (
        editIndex === null ||
        editIndex < 0 ||
        editIndex === ticketSubcategoryType.length - 1
      ) {
        const lastItem = prevList[prevList.length - 1];
        lastItem.CategoryId = "";
        lastItem.Name = "";
        lastItem.Desc = "";
        return prevList.slice(0, -1);
      }
      const item = prevList[editIndex];
      const isEmpty =
        !item?.Name?.trim() &&
        !item?.CategoryId?.toString().trim() &&
        !item?.Desc?.trim();
      if (isEmpty) {
        const updated = [...prevList];
        updated.splice(editIndex, 1);
        return updated;
      }

      if (item?.Id > 0) {
        getMasterTicketSubCategory();
      }

      return prevList;
    });
    subCategoryForm.resetForm();
    setEditIndex(null);
  };

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>
            Employee Request Sub-Category ({ticketSubcategoryType?.length})
          </h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                SubCategory
              </button>
            )}
          </div>
        </div>

        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {ticketSubcategoryType?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <Dropdown
                          value={subCategoryForm.values.CategoryId}
                          options={ticketCategoryType}
                          onChange={(e) => {
                            subCategoryForm.setFieldValue(
                              "CategoryId",
                              e.value
                            );
                            const updatedList = [...ticketSubcategoryType];
                            updatedList[index].CategoryId = e.value;
                            setTicketSubcategoryType(updatedList);
                            subCategoryForm.setFieldTouched(
                              `ticketSubcategoryType.${index}.CategoryId`,
                              true
                            );
                            validateOrgRequestSubCategory(
                              updatedList[index],
                              index
                            );
                          }}
                          className="filledannoucement w-100"
                          optionLabel="Name"
                          optionValue="Id"
                          filter={true}
                          placeholder="Choose..."
                          checkmark={true}
                          highlightOnSelect={false}
                        />
                        {errors[`${index}-CategoryId`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-CategoryId`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <input
                          type="text"
                          value={data.Name}
                          onChange={(e) => {
                            subCategoryForm.setFieldValue(
                              "Name",
                              e.target.value
                            );
                            const updatedList = [...ticketSubcategoryType];
                            updatedList[index].Name = e.target.value;
                            setTicketSubcategoryType(updatedList);
                            subCategoryForm.setFieldTouched(
                              `ticketSubcategoryType.${index}.Name`,
                              true
                            );
                            validateOrgRequestSubCategory(
                              updatedList[index],
                              index
                            );
                          }}
                          placeholder="Sub-Category"
                          className={`form-control ${
                            errors[`${index}-Name`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-Name`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Name`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <input
                          type="text"
                          value={data.Desc}
                          onChange={(e) => {
                            subCategoryForm.setFieldValue(
                              "Desc",
                              e.target.value
                            );
                            const updatedList = [...ticketSubcategoryType];
                            updatedList[index].Desc = e.target.value;
                            setTicketSubcategoryType(updatedList);
                            subCategoryForm.setFieldTouched(
                              `ticketSubcategoryType.${index}.Desc`,
                              true
                            );
                            validateOrgRequestSubCategory(
                              updatedList[index],
                              index
                            );
                          }}
                          placeholder="Designation Desc"
                          className={`form-control ${
                            errors[`${index}-Desc`] ? "is-invalid" : ""
                          }`}
                        />
                        {errors[`${index}-Desc`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Desc`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <>
                          <img
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                            onClick={handleCancelEdit}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            onClick={() => {
                              const item = ticketSubcategoryType[index];
                              subCategoryForm.setValues({
                                CategoryId: item.CategoryId,
                                Name: item.Name,
                                Desc: item.Desc,
                                Id: item.Id,
                                CreatedDate: item.CreatedDate,
                              });
                              if (validateOrgRequestSubCategory(item, index)) {
                                subCategoryForm.handleSubmit();
                                setEditIndex(null);
                              }
                            }}
                            className="editactions"
                            style={{ width: "17px" }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>
                        {ticketCategoryType.find(
                          (cat) => cat.Id === data.CategoryId
                        )?.Name || ""}
                      </td>

                      <td>{data?.Name}</td>

                      <td>{data?.Desc}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-subCategory"
                          onClick={() => {
                            handleEmpReqCategory(data?.Id);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-subCategory">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Employee Sub Category?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgEmpRequestCategory()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default EmployeeRequestSubCategory;
